import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { StudiesFacade } from '../../../../../shared-new/store/studies/studies.facade';
import { DocumentTypeModalComponent } from '../../../../edit-clinical-study-profile/components/document-type-modal/document-type-modal.component';
import { SaleMediaConversionLog } from 'src/app/models/sales/sale-media-conversion-log.model';

@Component({
  selector: 'app-asset-table',
  templateUrl: './asset-table.component.html',
  styleUrls: ['./asset-table.component.scss'],
})
export class AssetTableComponent implements OnChanges {
  @Input() studyFiles: StudyFile[] = [];
  // @Input() statuses: Status[] = [];
  // @Input() showStamped: boolean = false;
  // @Input() openButtonText: string = 'Items';
  @Input() headingText: string;
  @Input() required: boolean = false;
  // @Input() isUserSaleEditor: boolean = false;
  @Output() openButtonClicked = new EventEmitter();
  @Output() deleteFileClicked = new EventEmitter();

  @Output() updateStatus = new EventEmitter();
  @Input() conversionLogMap?: { [studyFileId: number]: SaleMediaConversionLog };

  displayedColumns: string[] = [
    'fileName',
    'videoType',
    'details',
    'uploadedby',
    'uploadeddate',
    'status',
    'action',
  ];
  dataSource: any = [];
  constructor(private modalService: NgbModal, private studyFacade: StudiesFacade) {
    this.dataSource = [...this.studyFiles];
  }

  getAssignedToBeCount() {
    const unAssigned = this.studyFiles.filter(x => !x.documentTypeName)
    return unAssigned.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const studyFiles = changes['studyFiles'];
    if (studyFiles && studyFiles?.currentValue) {
      this.dataSource = new MatTableDataSource<StudyFile>(this.studyFiles);
    }
  }
  // getStatusName(statusId: number): any {
  //   const selectedStatus = this.statuses.find(status => status.id === statusId);
  //   return selectedStatus ? selectedStatus.altName : "";
  // }
  onChangeStatus($event: any, studyFileIds: number[]): void {
    const statusId = $event?.target?.value;
    this.emitStatusUpdate(studyFileIds, statusId);
  }

  emitStatusUpdate(studyFileIds: number[], statusId: string): void {
    this.updateStatus.emit({ studyFileIds, statusId: parseInt(statusId) });
  }

  emitOpenButtonClicked(studyFileId: number): void {
    this.openButtonClicked.emit(studyFileId);
  }

  emitDeleteButtonClicked(studyFileId: number): void {
    this.deleteFileClicked.emit(studyFileId);
  }

  getConversionError(studyFileId: number): SaleMediaConversionLog | null {
    if (!this.conversionLogMap) {
      return null;
    }
    const log = this.conversionLogMap[studyFileId];
    if (log && !log.isSuccess) {
      return log;
    }
    return null;
  }

  openDocTypePopup(studyFile: StudyFile, isReport: boolean): void {
    const modalRef = this.modalService.open(DocumentTypeModalComponent, {
      ariaLabelledBy: 'templatePopup',
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = {
      studyFileId: studyFile.studyFileId,
      docTypeId: studyFile.documentTypeId,
      isReport: isReport
    };
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        this.studyFacade.updateStudyDocType(
          data.studyFileId,
          data.docTypeId,
          data.docTypeName,
          isReport
        );
      },
      (reason) => { }
    );
  }

  transformData(
    studyFile: StudyFile,
    studyFileIds: number[]
  ): {
    studyFileIds: number[];
    submittedBy: string;
    date: string;
    imageCount: number;
    stamped: boolean;
    status: number;
    statusMessage: string;
  } {
    const model = {
      studyFileIds: studyFileIds,
      submittedBy: studyFile.createdByUser.name,
      date: studyFile.studyStatusDate,
      imageCount: studyFileIds.length,
      stamped: studyFile.isStamped,
      status: studyFile.studyStatusId,
      statusMessage: studyFile.statusMessage,
    };

    return model;
  }
}
